module.exports = __webpack_public_path__ + "static/img/bg.0be2046.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg.png
// module id = C34Q
// module chunks = 1